<div
	class="h-fit"
	[ngClass]="sliderRefName"
>
	<swiper-container
		#swiperRef
		init="false"
	>
		<ng-content select="slider-item-web-ay" />
	</swiper-container>
	<ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
</div>

<ng-template #footerTemplate>
	@if (options?.pagination ?? true) {
		<div class="flex justify-center px-2 pb-2 pt-4">
			<uikit-button
				type="tonal"
				icon="angle-left-b"
				radius="full"
				size="small"
				class="prev-btn"
			/>
			<div class="swiper-pagination-custom"></div>
			<uikit-button
				type="tonal"
				icon="angle-right-b"
				radius="full"
				size="small"
				class="next-btn"
			/>
		</div>
	}
</ng-template>
